import tickerEditorIepsResp from './data/tickerEditorIeps';

export const TickerEditorIeps = (req, res, ctx) => {
  return res(
    // Respond with a 200 status code
    ctx.status(200),
    ctx.json(tickerEditorIepsResp),
  );
};
